//framer-variants for page transition
const AnimPage = {
	hidden: { opacity: 0, y: 400 },
	show: { opacity: 1, y: 0, transition: { duration: 1 } },
	exit: { opacity: 0, y: 400, transition: { duration: 1 } },
};

// framer-variants for about page
const animTitle = {
	hidden: { opacity: 0, y: 400 },
	show: { opacity: 1, y: 0, transition: { duration: 1.5 } },
};

const animTitle2 = {
	hidden: { opacity: 0, y: 400 },
	show: { opacity: 1, y: 0, transition: { duration: 1.8 } },
};

const animTitle3 = {
	hidden: { opacity: 0, y: 400 },
	show: { opacity: 1, y: 0, transition: { duration: 2 } },
};

const fade = {
	hidden: { opacity: 0 },
	show: { opacity: 1, transition: { duration: 3} },
};

const animPhoto = {
	hidden: { scale: 0.5, opacity: 0 },
	show: {
		scale: 1,
		opacity: 1,
		transition: {
			ease: "easeOut",
			duration: 1.5,
		},
	},
};

const animLine = {
	hidden: { width: "0%" },
	show: { width: "100%", transition : { duration : 1} },
};

export { AnimPage, animTitle, animTitle2, animTitle3, fade, animPhoto, animLine };
